import {PersianNumberPipe} from '../pipes/persian-number.pipe';

export const APP_CONST = {
  getSessionsTimeList: () => {
    return [
      {
        title: `${PersianNumberPipe.convertToPersianNumber((30).toString())} دقیقه `,
        value: 30,
      },
      ...Array.from(Array(24).keys()).map(item => {
        return {
          title: `${PersianNumberPipe.convertToPersianNumber((item + 1).toString())} ساعت `,
          value: (item + 1)*60,
        };
      }),
    ];
  },
};
